import { axios } from 'system/axios'

export const cancelMembership = (membershipId: string) =>
  axios.post<{ success: boolean }>(`/membership/${membershipId}/cancel`)
